<template>
  <div class="NotFound">
    <section class="page-not-found garden-set-pd">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="box-image">
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1577363023/afrikeveil/404.png"
                alt=""
              />
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="box-content">
              <h1>Oops!</h1>
              <p>
                {{ $t("404") }}
              </p>
              <div class="garden-button garden-button-v2">
                <a href="/">{{ $t("navBar.home") }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  created() {
    document.title = 404;
  },
  name: "NotFound"
};
</script>
<style scoped>
.garden-button-v2 a {
  text-transform: capitalize;
}
</style>
